import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $mediator from 'wee-mediator';

class SiteAlert {
    init() {
        this.cookieName = 'ascendAlertClose';
        this.closedAlerts = this.getCookie().map(x => parseInt(x));

        $events.on({
            '.js-close-alert': {
                click: () => {
                    this.removeAlert();
                },
            },
        });

        $('.js-site-alert').each((alert) => {
            const $alert = $(alert);

            if (! this.checkCookie($alert.data('id') + '')) {
                $alert.removeClass('-hidden');
            }
        });
    }

    removeAlert() {
        const $alert = $('.js-site-alert');

        if ($alert.length) {
            this.closedAlerts.push($alert.data('id'));
            this.setCookie();

            $alert.css('height', $alert.height() + 'px');

            window.setTimeout(() => {
                $alert.css('height', 0);
            }, 0);

            window.setTimeout(() => {
                $alert.remove();

                $mediator.emit('removeAlert');
            }, 250);
        }
    }

    checkCookie(alertId) {
        const alertIds = this.getCookie();

        if (alertIds.indexOf(alertId) > -1) {
            return true;
        }

        return false;
    }

    getCookie() {
        const cookieMatch = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));

        if (cookieMatch) {
            return cookieMatch[2].split(',');
        }

        return [];
    }

    setCookie() {
        document.cookie = `${this.cookieName}=${this.closedAlerts.join(',')};path=/;max-age=31536000`;
    }
}

export default new RouteHandler({
    init() {
        const siteAlert = new SiteAlert();

        siteAlert.init();
    },
});
